import en from './en';
import fr from './fr';
import he from './he';
import ru from './ru';
import ar from './ar';

export default {
    en: {
        message: en
    },
    fr: {
        message: fr
    },
    he: {
        message: he
    },
    ru: {
        message: ru
    },
    ar: {
        message: ar
    }
}